const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget click record; keepalive lets it complete even if the dialer/new tab opens.
export const trackEvent = (kind, page, placement) => {
  try {
    fetch(`${API}/track/event`, {
      method: "POST",
      keepalive: true,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ kind, page, placement }),
    }).catch(() => {});
  } catch {
    /* tracking must never block the user action */
  }
};
